import { propIs } from 'utils';

import { ICartEntry } from '@rbi-ctg/menu';
import { IsCartEntryType } from 'state/menu/types';
import { CartEntryType } from 'utils/cart/types';

export const isCartEntryCombo = () => propIs<ICartEntry>('type', CartEntryType.combo);

export const isCartEntryWithTypeCombo = isCartEntryCombo() as IsCartEntryType<ICartEntry>;
